import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const SoundMutedIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M2.564 1.43a.806.806 0 0 1 1.14 0l11.54 11.54a.806.806 0 0 1-1.14 1.14L2.564 2.57a.806.806 0 0 1 0-1.14m.665 3.929a1 1 0 0 0-.234.643V10a1 1 0 0 0 1 1h3l4.445 3.834c.399.265.878.2 1.198-.066l-9.41-9.41Zm9.766 3.243v-6.6a1 1 0 0 0-1.555-.832L8.284 3.89z"
		></path>
	</svg>
))
